<template>
  <div class="add_pricing_modal">
    <widgetModal :title="modalType" btnlefttext="Cancel" btnrighttext="Save" :leftloading="submitingLoading"
      :rightloading="false" :footerhidden="false" @onLeftClick="onComfirm" @onRightClick="onClose">
      <div class="widget-modal-body">
        <b-field v-if="type != 'gallery'" label="Image" style="width: 100%">
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
            location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
            :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.image" @onFileSelected="(file) => {
              form.image = file;
            }">
            <div class="image-upload-widget">Choose Image to upload</div>
          </upload-trigger>
        </b-field>
        <b-field label="Name" style="width: 100%" v-if="type === 'member'">
          <b-input v-model="form.name"></b-input>
        </b-field>
        <b-field v-if="type != 'gallery'" label="Title" style="width: 100%">
          <b-input v-model="form.title"></b-input>
        </b-field>
        <b-field v-if="type != 'gallery'" label="Description">
          <b-input v-model="form.description" maxlength="500" type="textarea"></b-input>
        </b-field>
        <b-field label="Summary" v-if="type === 'member'">
          <b-input v-model="form.summary" maxlength="500" type="textarea"></b-input>
        </b-field>
        <b-field label="Full information" v-if="type === 'member'">
          <b-input v-model="form.fullInfo" maxlength="500" type="textarea"></b-input>
        </b-field>
        <b-field label="Phone" style="width: 100%" v-if="type === 'about'">
          <b-input v-model="form.phone"></b-input>
        </b-field>
        <b-field label="Email" style="width: 100%" v-if="type === 'about'">
          <b-input v-model="form.email"></b-input>
        </b-field>

        <b-field label="Vision" style="width: 100%" v-if="type === 'about'">
          <b-input v-model="form.vision" maxlength="500" type="textarea"></b-input>
        </b-field>
        <b-field label="Mission" style="width: 100%" v-if="type === 'about'">
          <b-input v-model="form.mission" maxlength="500" type="textarea"></b-input>
        </b-field>
        <b-field label="Values" style="width: 100%" v-if="type === 'about'">
          <b-input v-model="form.values" maxlength="500" type="textarea"></b-input>
        </b-field>

        <b-field label="Link" v-if="type === 'slide' || type === 'project'">
          <b-input v-model="form.link"></b-input>
        </b-field>
        <b-field label="Links" style="width: 100%" v-if="type === 'about' || type === 'member'"></b-field>
        <b-field label="Instagram" style="display: block;" v-if="type === 'about' || type === 'member'">
          <b-input v-model="form.instagramLink"></b-input>
        </b-field>
        <b-field label="Facebook" style="display: block;" v-if="type === 'about' || type === 'member'">
          <b-input v-model="form.facebookLink"></b-input>
        </b-field>
        <b-field label="Linkedin" style="display: block;" v-if="type === 'about' || type === 'member'">
          <b-input v-model="form.linkedinLink"></b-input>
        </b-field>
        <b-field label="X" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.xLink"></b-input>
        </b-field>
        <b-field label="Tiktok" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.tiktokLink"></b-input>
        </b-field>
        <b-field label="Youtube" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.youtubeLink"></b-input>
        </b-field>
        <b-field label="Spotify" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.spotifyLink"></b-input>
        </b-field>
        <b-field label="Sound Cloud" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.soundcloudLink"></b-input>
        </b-field>
        <b-field label="Vimeo" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.vimeoLink"></b-input>
        </b-field>
        <b-field label="Twitch" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.twitchLink"></b-input>
        </b-field>
        <b-field label="Apple Music" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.applemusicLink"></b-input>
        </b-field>
        <b-field label="Bandcamp" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.bandcampLink"></b-input>
        </b-field>
        <b-field label="Triller" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.trillerLink"></b-input>
        </b-field>
        <b-field label="Vevo" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.vevoLink"></b-input>
        </b-field>
        <b-field label="Deezer" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.deezerLink"></b-input>
        </b-field>
        <b-field label="Smule" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.smuleLink"></b-input>
        </b-field>
        <b-field label="Pinterest" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.pinterestLink"></b-input>
        </b-field>
        <b-field label="Whatsapp" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.whatsappLink"></b-input>
        </b-field>
        <b-field label="Reddit" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.redditLink"></b-input>
        </b-field>
        <b-field label="Audiomack" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.audiomackLink"></b-input>
        </b-field>
        <b-field label="Boomplay" style="display: block;" v-if="type === 'about'">
          <b-input v-model="form.boomplayLink"></b-input>
        </b-field>
        <b-field v-if="type === 'gallery'" label="Select Gallery images" style="width: 100%">
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="true"
            location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
            :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.gallery" @onFileSelected="(file) => {
              form.gallery = file;
            }">
            <div v-if="!form.gallery" class="image-upload-widget">Choose Images to upload</div>
          </upload-trigger>
        </b-field>
      </div>
    </widgetModal>
  </div>
</template>

<script>
export default {
  name: "add_edit_website_theme",
  props: {
    current: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: null
    }
  },
  components: {},
  data() {
    return {
      submitingLoading: false,
      resetingLoading: false,
      form: {
        image: '',
        title: '',
        name: '',
        description: '',
        summary: '',
        fullInfo: '',
        link: '',
        tags: '',
        email: '',
        phone: '',
        instagramLink: '',
        facebookLink: '',
        linkedinLink: '',
        xLink: '',
        tiktokLink: '',
        youtubeLink: '',
        spotifyLink: '',
        soundcloudLink: '',
        vimeoLink: '',
        twitchLink: '',
        applemusicLink: '',
        bandcampLink: '',
        trillerLink: '',
        vevoLink: '',
        deezerLink: '',
        smuleLink: '',
        pinterestLink: '',
        whatsappLink: '',
        redditLink: '',
        audiomackLink: '',
        boomplayLink: '',
        gallery: null,
      },
    };
  },
  computed: {
    modalType() {
      const modalTitles = {
        slide: this.current.id ? "EDIT SLIDE" : "ADD NEW SLIDE",
        service: this.current.id ? "EDIT SERVICE" : "ADD NEW SERVICE",
        project: this.current.id ? "EDIT PROJECT" : "ADD NEW PROJECT",
        member: this.current.id ? "EDIT MEMBER" : "ADD NEW MEMBER",
        about: "EDIT YOUR ABOUT US",
        gallery: "EDIT GALLERY",
      };

      return modalTitles[this.type] || "";
    }
  },
  mounted() {
    let vm = this;
    if (vm.current) {
      vm.setFormFields();
    } else {
      vm.resetFormFields();
    }
  },
  methods: {
    resetFormFields() {
      let vm = this;
      vm.form = {
        id: null,
        image: '',
        title: '',
        name: '',
        description: '',
        summary: '',
        email: '',
        vision: '',
        mission: '',
        values: '',
        fullInfo: '',
        link: '',
        tags: '',
        phone: '',
        instagramLink: '',
        facebookLink: '',
        linkedinLink: '',
        xLink: '',
        tiktokLink: '',
        youtubeLink: '',
        spotifyLink: '',
        soundcloudLink: '',
        vimeoLink: '',
        twitchLink: '',
        applemusicLink: '',
        bandcampLink: '',
        trillerLink: '',
        vevoLink: '',
        deezerLink: '',
        smuleLink: '',
        pinterestLink: '',
        whatsappLink: '',
        redditLink: '',
        audiomackLink: '',
        boomplayLink: '',
        gallery: null,
      };
    },
    setFormFields() {
      let vm = this;
      vm.form = {
        id: !vm.current.id ? null : vm.current.id,
        image: vm.current.image,
        name: vm.current.name,
        title: vm.current.title,
        email: vm.current.email,
        description: vm.current.description,
        summary: vm.current.summary,
        fullInfo: vm.current.fullInformation,
        link: vm.current.link,
        tags: vm.current.tags,
        phone: vm.current.phone,
        vision: vm.current.vision,
        mission: vm.current.mission,
        values: vm.current.values,
        instagramLink: vm.current.instagramLink,
        facebookLink: vm.current.facebookLink,
        linkedinLink: vm.current.linkedinLink,
        xLink: vm.current.xLink,
        tiktokLink: vm.current.tiktokLink,
        youtubeLink: vm.current.youtubeLink,
        spotifyLink: vm.current.spotifyLink,
        soundcloudLink: vm.current.soundcloudLink,
        vimeoLink: vm.current.vimeoLink,
        twitchLink: vm.current.twitchLink,
        applemusicLink: vm.current.applemusicLink,
        bandcampLink: vm.current.bandcampLink,
        trillerLink: vm.current.trillerLink,
        vevoLink: vm.current.vevoLink,
        deezerLink: vm.current.deezerLink,
        smuleLink: vm.current.smuleLink,
        pinterestLink: vm.current.pinterestLink,
        whatsappLink: vm.current.whatsappLink,
        redditLink: vm.current.redditLink,
        audiomackLink: vm.current.audiomackLink,
        boomplayLink: vm.current.boomplayLink,
        gallery: vm.current.gallery ? vm.current.gallery : null,
      };
    },
    onComfirm() {
      let vm = this;
      // Start validate
      const rules = {};

      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.submitingLoading = true;
        if (vm.modalType == "ADD NEW SLIDE") {
          vm.$store
            .dispatch("SLIDES_ADD_NEW_SLIDE", vm.form)
            .then((response) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: response.data.message,
              });
              vm.onClose()
              vm.$emit("success", 'slides');
            })
            .catch(({ response }) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "Message",
                text: response.data.message,
              });
            });
        }
        else if (vm.modalType == "EDIT SLIDE") {
          vm.$store
            .dispatch("SLIDES_UPDATE_SLIDE", vm.form)
            .then((response) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: response.data.message,
              });
              vm.onClose()
              vm.$emit("success", 'slides');
            })
            .catch(({ response }) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "Message",
                text: response.data.message,
              });
            });
        }
        else if (vm.modalType == "ADD NEW SERVICE") {
          vm.$store
            .dispatch("SERVICES_ADD_NEW_SERVICE", vm.form)
            .then((response) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: response.data.message,
              });
              vm.onClose()
              vm.$emit("success", 'services');
            })
            .catch(({ response }) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "Message",
                text: response.data.message,
              });
            });
        }
        else if (vm.modalType == "EDIT SERVICE") {
          vm.$store
            .dispatch("SERVICES_UPDATE_SERVICE", vm.form)
            .then((response) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: response.data.message,
              });
              vm.onClose()
              vm.$emit("success", 'services');
            })
            .catch(({ response }) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "Message",
                text: response.data.message,
              });
            });
        }
        else if (vm.modalType == "ADD NEW PROJECT") {
          vm.$store
            .dispatch("PROJECTS_ADD_NEW_PROJECT", vm.form)
            .then((response) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: response.data.message,
              });
              vm.onClose()
              vm.$emit("success", 'projects');
            })
            .catch(({ response }) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "Message",
                text: response.data.message,
              });
            });
        }
        else if (vm.modalType == "EDIT PROJECT") {
          vm.$store
            .dispatch("PROJECTS_UPDATE_PROJECT", vm.form)
            .then((response) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: response.data.message,
              });
              vm.onClose()
              vm.$emit("success", 'projects');
            })
            .catch(({ response }) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "Message",
                text: response.data.message,
              });
            });
        }
        else if (vm.modalType == "ADD NEW MEMBER") {
          vm.$store
            .dispatch("MEMBERS_ADD_NEW_MEMBER", vm.form)
            .then((response) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: response.data.message,
              });
              vm.onClose()
              vm.$emit("success", 'members');
            })
            .catch(({ response }) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "Message",
                text: response.data.message,
              });
            });
        }
        else if (vm.modalType == "EDIT MEMBER") {
          vm.$store
            .dispatch("MEMBERS_UPDATE_MEMBER", vm.form)
            .then((response) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: response.data.message,
              });
              vm.onClose()
              vm.$emit("success", 'members');
            })
            .catch(({ response }) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "Message",
                text: response.data.message,
              });
            });
        }
        else if (vm.modalType == "EDIT YOUR ABOUT US") {
          vm.$store
            .dispatch("ABOUT_UPDATE_INFO_ABOUT", vm.form)
            .then((response) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: response.data.message,
              });
              vm.onClose()
              vm.$emit("success", 'about');
            })
            .catch(({ response }) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "Message",
                text: response.data.message,
              });
            });
        }
        else if (vm.modalType == "EDIT GALLERY") {
          vm.$store
            .dispatch("GALLERY_UPDATE_IMAGES", vm.form)
            .then((response) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: response.data.message,
              });
              vm.onClose()
              vm.$emit("success", 'about');
            })
            .catch(({ response }) => {
              vm.submitingLoading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "Message",
                text: response.data.message,
              });
            });
        }
      }
    },
    onClose() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped></style>